import { Typography } from "storybook/components/typography/index.tsx";
import { ContentContainer, PageContainer } from "../common/styles";
import { ComingSoonIcon } from "./coming-soon-icon";
import { ComingSoonIconContainer } from "./styles.ts";

export function Education() {
  return (
    <PageContainer>
      <ContentContainer>
        <ComingSoonIconContainer>
          <ComingSoonIcon />
          <Typography
            variant="body2"
            theme="default"
            color="black"
            component="p"
          >
            Coming Soon
          </Typography>
        </ComingSoonIconContainer>
      </ContentContainer>
    </PageContainer>
  );
}
